<template>
  <div class="pages-common-products-grid">
    <div v-for="product in props.products" :key="product.id" class="pages-common-products-grid__item">
      <div v-if="product.listingImage?.responsiveImage" class="pages-common-products-grid__item__image">
        <WidgetPicture
          class="is-cover"
          :image="{ custom: product.listingImage?.responsiveImage}"
          :lazyLoad="true"
          :alt="product.listingImage?.responsiveImage?.alt"
        />
      </div>

      <div class="pages-common-products-grid__item__title title-m-2 ">
        {{ product.name }}
      </div>

      <div class="pages-common-products-grid__item__extract is-xlight text-corpo-m" v-html="product.listingExtract" />

      <div class="pages-common-products-grid__cta">
        <WidgetArrowLink
          :label="product.listingCtaLabel || $t('cta.goToProduct')"
          :link="
            localePath({
              name: 'product-slug',
              params: { slug: product.slug },
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonProductsGrid',
}
</script>

<script setup>
const props = defineProps({
  products: {
    type: Array,
    default: () => ([])
  }
})
</script>

<style lang="scss">
@import './style.scss';
</style>
